/* C254 (Justin 2026-09-22): blanks catalogue collection behaviour, ported from the dtftransfers build
   (Claude Folders/BLANKS-CATALOG-UI-HANDOFF.md section 5). Only runs on a page carrying .npbc-head.

   Three jobs: make the filter groups collapsible and closed by default, put a colour chip on the Colors facet, and
   render a toolbar whose sort control NAVIGATES rather than trying to drive the theme's hidden select. */
(function () {
  'use strict';
  if (!document.querySelector('.npbc-head')) return;
  if (window.__npBlanksCollection) return;
  window.__npBlanksCollection = true;

  /* colour families the facet actually uses; the shared per-colour table (np-blanks-swatch-colors.js) covers catalogue
     colour names, but facet values are broad families like "Brown", so this fallback answers those. */
  var FAMILY = {
    black: '#111111', white: '#ffffff', grey: '#9a9a9a', gray: '#9a9a9a', silver: '#c9ccce',
    blue: '#2f5fa8', navy: '#1f2a44', green: '#2f7d4f', olive: '#6b7042', red: '#c0392b',
    maroon: '#7b1f2b', orange: '#e2703a', yellow: '#e8c23c', gold: '#c8a02c', pink: '#e08aa8',
    purple: '#6b4a9c', brown: '#6b4a34', tan: '#c3a887', khaki: '#c1b49a', cream: '#efe6d3',
    teal: '#2b7d84', turquoise: '#3fb6b6', camo: '#5a6448', clear: '', natural: '#e7dcc6'
  };
  function hexFor(name) {
    var n = String(name || '').trim().toLowerCase();
    if (!n) return null;
    var table = window.NP_BLANK_COLORS || window.NT_BLANK_COLORS || window.__npBlanksColorMap;
    if (table) {
      var up = n.toUpperCase().replace(/\s+/g, ' ');
      if (table[up]) return table[up];
    }
    if (FAMILY[n]) return FAMILY[n];
    for (var k in FAMILY) { if (FAMILY.hasOwnProperty(k) && n.indexOf(k) > -1) return FAMILY[k]; }
    return null;
  }

  /* ── collapsible facet groups ────────────────────────────────────────────────────────────────
     Open/closed is remembered BY GROUP NAME, because choosing a filter makes the theme re-render the
     whole facets form. The handoff's first version marked groups wired mid-render and they stayed
     permanently expanded, which read as "choosing one filter opens all the others". */
  var openGroups = Object.create(null);

  function groupName(g) {
    var s = g.querySelector('.facets__summary-text, summary span, summary');
    return s ? s.textContent.replace(/\s+/g, ' ').trim() : '';
  }
  function bodyParts(g) {
    /* hide EVERYTHING except the header: most groups wrap options in <show-more>, but Price renders a
       price-range plus its own inputs as siblings, so hiding one named element leaves the slider visible. */
    return Array.prototype.filter.call(g.children, function (c) {
      return !/^summary$/i.test(c.tagName) && !c.classList.contains('facets__summary-text');
    });
  }
  function setOpen(g, open) {
    bodyParts(g).forEach(function (el) { el.style.display = open ? '' : 'none'; });
    g.classList.toggle('is-open', open);
    var name = groupName(g);
    if (name) openGroups[name] = open;
    if (g.tagName === 'DETAILS') g.open = open;
  }

  /* C265: accordion — at most one group open at a time, all closed on arrival, matching
     dtftransferss. Twelve facets expanded at once buried the grid below a screen of checkboxes.
     Closing siblings goes through setOpen so openGroups stays the single source of truth across
     the re-render the theme does on every filter change. */
  function openOnly(g) {
    document.querySelectorAll('.facets__disclosure').forEach(function (other) {
      if (other !== g && other.classList.contains('is-open')) setOpen(other, false);
    });
    setOpen(g, true);
  }
  function wireGroups(root) {
    (root || document).querySelectorAll('.facets__disclosure').forEach(function (g) {
      /* only mark a group wired once it actually HAS children — see the note above */
      if (!g.children.length) return;
      if (g.getAttribute('data-npbc-acc')) { return; }
      g.setAttribute('data-npbc-acc', '1');
      var name = groupName(g);
      var open = name && Object.prototype.hasOwnProperty.call(openGroups, name) ? openGroups[name] : false;
      setOpen(g, open);
      var head = g.querySelector('summary, .facets__summary-text');
      if (head) {
        head.style.cursor = 'pointer';
        head.addEventListener('click', function (e) {
          e.preventDefault();
          if (g.classList.contains('is-open')) setOpen(g, false);
          else openOnly(g);
        });
      }
    });
  }

  /* ── colour chips on the Colors facet ───────────────────────────────────────────────────────── */
  function paintSwatches(root) {
    (root || document).querySelectorAll('.facets__disclosure').forEach(function (g) {
      if (!/colou?rs?/i.test(groupName(g))) return;
      g.querySelectorAll('label').forEach(function (lab) {
        if (lab.querySelector('.npbc-swatch')) return;
        var input = lab.querySelector('input') || (lab.htmlFor && document.getElementById(lab.htmlFor));
        var name = (lab.textContent || '').replace(/\(\d+\)\s*$/, '').replace(/\s+/g, ' ').trim();
        if (!name) return;
        var hex = hexFor(name);
        var sw = document.createElement('span');
        sw.className = 'npbc-swatch' + (hex ? '' : ' npbc-swatch--none');
        if (hex) sw.style.backgroundColor = hex;
        var anchor = lab.querySelector('.styled-checkbox, input');
        if (anchor && anchor.nextSibling) lab.insertBefore(sw, anchor.nextSibling);
        else lab.insertBefore(sw, lab.firstChild);
      });
    });
  }

  /* ── toolbar ────────────────────────────────────────────────────────────────────────────────
     The real sort select stays inside the facets form because the theme binds its handler there.
     Writing to it and dispatching change did nothing in the handoff's build, so the proxy navigates. */
  function buildToolbar() {
    var grid = document.getElementById('main-collection-product-grid');
    if (!grid || document.querySelector('.npbc-toolbar')) return;
    var head = document.querySelector('.npbc-head');
    var bar = document.createElement('div');
    bar.className = 'npbc-toolbar';

    /* C259: search field leads the toolbar, as on dtftransferss. */
    var search = document.createElement('div');
    search.className = 'npbc-toolbar__search';
    var input = document.createElement('input');
    input.type = 'search';
    input.className = 'npbc-toolbar__searchinput';
    input.placeholder = 'Search blanks...';
    input.setAttribute('aria-label', 'Search blanks');
    search.appendChild(input);
    bar.appendChild(search);

    var count = document.createElement('span');
    count.className = 'npbc-toolbar__count';
    /* count what is ON THE PAGE, not collection.products_count: sold-out blanks are filtered out of the grid
       (C238/C241), so the collection count reads higher than the shopper can see — 52 against 31 on Blank Hats. */
    /* C258: match dtftransferss — one plain count, no "N of M". When the grid is paginated the
       page-level count would understate the collection, so use the collection total there; on a
       single page what is rendered IS the truth (sold-out blanks are filtered out by C238/C241). */
    var n = grid.querySelectorAll('.product-item').length;
    var paginated = document.querySelector('.pagination, [class*="pagination"]');
    var total = Number((head && head.getAttribute('data-npbc-count')) || n) || n;
    var shown = paginated && total > n ? total : n;
    /* C397: with a filter on, the collection total is the wrong number; the theme's own count carries the filtered one */
    if (/[?&]filter\./.test(location.search)) {
      var tc = document.getElementById('CollectionProductCount');
      var tn = tc && (tc.textContent || '').replace(/,/g, '').match(/\d+/);
      if (tn) shown = Number(tn[0]);
    }
    count.textContent = shown + (shown === 1 ? ' product' : ' products');
    bar.appendChild(count);

    var real = document.querySelector('select[name="sort_by"]');
    if (real) {
      var wrap = document.createElement('div');
      wrap.className = 'npbc-toolbar__sort';
      var proxy = document.createElement('select');
      proxy.setAttribute('aria-label', 'Sort by');
      Array.prototype.forEach.call(real.options, function (o) {
        var opt = document.createElement('option');
        opt.value = o.value; opt.textContent = o.textContent;
        if (o.selected) opt.selected = true;
        proxy.appendChild(opt);
      });
      proxy.addEventListener('change', function () {
        var u = new URL(window.location.href);
        u.searchParams.set('sort_by', proxy.value);
        u.searchParams.delete('page');
        window.location.href = u.toString();
      });
      wrap.appendChild(proxy);
      bar.appendChild(wrap);
    }
    grid.parentNode.insertBefore(bar, grid);
    wireSearch(grid, input, count);
  }

  /* ── product search ─────────────────────────────────────────────────────────────────────────
     Matches TITLES over the whole collection, not the rendered page — a 763-product collection
     paginates at 40, so filtering the DOM would search 5% of the catalogue and quietly claim it
     searched all of it. Shopify's predictive endpoint under-returns on style codes (the handoff
     saw one hit for "g500" where four exist), so load /collections/<handle>/products.json once
     and match here. Loaded lazily on the first keystroke; nothing is fetched for shoppers who
     never search. */
  var SYN = { hoodi: ['hoodie', 'hooded'], hoodie: ['hoodie', 'hooded'], hooded: ['hoodie'], hat: ['hat', 'cap'], cap: ['cap', 'hat'],
    tee: ['tee', 't-shirt', 'tshirt'], 't-shirt': ['t-shirt', 'tee'], tshirt: ['t-shirt', 'tee'], crewneck: ['crewneck', 'crew neck'] };
  function wireSearch(grid, input, count) {
    if (!input || input.__npbcWired) return;
    input.__npbcWired = true;

    var handle = (location.pathname.match(/\/collections\/([^\/?#]+)/) || [])[1];
    if (!handle) { input.parentNode.style.display = 'none'; return; }

    var gridHTML = null, originalCount = count.textContent, catalogue = null, loading = null, timer = null;
    function snapshot() { if (gridHTML === null) gridHTML = grid.innerHTML; }

    function load() {
      if (catalogue) return Promise.resolve(catalogue);
      if (loading) return loading;
      loading = (function page(n, acc) {
        return fetch('/collections/' + handle + '/products.json?limit=250&page=' + n, { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : { products: [] }; })
          .then(function (d) {
            var ps = (d && d.products) || [];
            acc = acc.concat(ps);
            return ps.length === 250 && n < 8 ? page(n + 1, acc) : acc;
          });
      })(1, []).then(function (all) { catalogue = all; return all; });
      return loading;
    }

    function money(v) {
      var n = Number(v);
      return isNaN(n) ? '' : '$' + n.toFixed(2);
    }

    /* C384 (Justin 2026-09-23, "when a customer searches a blank it should open up in the blanks collection with the search
       query so that it matches our styling"): a hit is built as the theme's own collection card (.product-item with the
       image link, .product-item__price and .product-item__title), carrying the in-stock colour names the Liquid card carries
       (data-np-instock, from this product's available variants). The grid observer then runs decorateCards on it, so the
       swatches, AS LOW AS price and brand are the catalogue's exactly, and quick buy attaches the same way. */
    function colourIndex(p) {
      var opts = p.options || [];
      for (var i = 0; i < opts.length; i++) {
        var n = String((opts[i] && (opts[i].name || opts[i])) || '').toLowerCase();
        if (n === 'color' || n === 'colour') return i;
      }
      return -1;
    }
    function card(p) {
      var img = (p.images && p.images[0] && p.images[0].src) || '';
      var vs = p.variants || [];
      var prices = vs.map(function (v) { return Number(v.price); }).filter(function (x) { return !isNaN(x); });
      var low = prices.length ? Math.min.apply(null, prices) : null;
      var ci = colourIndex(p), seen = Object.create(null), stock = [];
      vs.forEach(function (v) {
        if (!v.available || ci < 0) return;
        var nm = String(v['option' + (ci + 1)] || '').trim().toUpperCase();
        if (nm && !seen[nm]) { seen[nm] = 1; stock.push(nm); }
      });
      var href = '/collections/' + handle + '/products/' + p.handle;
      var el = document.createElement('div');
      el.className = 'product-item npbc-hit';
      el.setAttribute('data-js-product-item', '');
      if (stock.length) el.setAttribute('data-np-instock', '|' + stock.join('|') + '|');
      var a = document.createElement('a');
      a.className = 'product-item__image';
      a.href = href;
      a.style.paddingTop = '100%';
      var fig = document.createElement('figure');
      fig.className = 'lazy-image lazy-image--background product-item__image-figure product-item__image-figure--top product-item__image-no-slider lazyloaded';
      fig.style.paddingTop = '100%';
      /* the theme lays the photo over the frame only when the frame carries data-ratio (theme.css .lazy-image[data-ratio]) */
      fig.setAttribute('data-ratio', '1');
      fig.setAttribute('data-crop', 'false');
      if (img) {
        var i = document.createElement('img');
        i.className = 'img'; i.loading = 'lazy'; i.alt = p.title || '';
        i.setAttribute('data-ratio', '1');
        i.src = img.replace(/(\.[a-z]+)(\?|$)/i, '_480x$1$2');
        fig.appendChild(i);
      }
      a.appendChild(fig);
      el.appendChild(a);
      var text = document.createElement('div');
      text.className = 'card__text product-item__text gutter-top--regular gutter-bottom--regular spacing--xlarge remove-empty-space text-align--left';
      if (low !== null) {
        var pr = document.createElement('div');
        pr.className = 'product-item__price text-size--small equalize-white-space';
        pr.textContent = money(low);
        text.appendChild(pr);
      }
      var t = document.createElement('a');
      t.className = 'product-item__title';
      t.href = href;
      t.title = p.title || '';
      var tw = document.createElement('div'); tw.className = 'remove-line-height-space--small';
      var ts = document.createElement('span'); ts.className = 'text-animation--underline-thin text-size--large text-weight--bold';
      ts.textContent = p.title || '';
      tw.appendChild(ts); t.appendChild(tw); text.appendChild(t);
      el.appendChild(text);
      return el;
    }

    function restore() {
      if (gridHTML !== null) { grid.innerHTML = gridHTML; gridHTML = null; }
      count.textContent = originalCount;
      document.body.classList.remove('npbc-searching');
    }

    function render(q) {
      load().then(function (all) {
        if (input.value.trim().toLowerCase() !== q) return;   /* a later keystroke already won */
        var terms = q.split(/\s+/).filter(Boolean);
        /* C384: the site search forwards here, and Shopify's search also reads tags and SKUs and forgives plurals, so
           match those too — a forwarded "hoodies" or style code must not land on "No blanks match" */
        var hits = all.filter(function (p) {
          var tags = Array.isArray(p.tags) ? p.tags.join(' ') : (p.tags || '');
          var skus = (p.variants || []).map(function (v) { return v.sku || ''; }).join(' ');
          var hay = ((p.title || '') + ' ' + (p.vendor || '') + ' ' + (p.product_type || '') + ' ' + tags + ' ' + skus).toLowerCase();
          return terms.every(function (t) {
            if (hay.indexOf(t) > -1) return true;
            var stem = t.length > 3 && /s$/.test(t) ? t.replace(/e?s$/, '') : t;
            if (stem !== t && hay.indexOf(stem) > -1) return true;
            /* everyday names the titles spell differently ("Hooded Sweatshirt", "Trucker Cap", "T-Shirt") */
            var alts = SYN[stem] || SYN[t];
            return !!alts && alts.some(function (a) { return hay.indexOf(a) > -1; });
          });
        });
        snapshot();
        document.body.classList.add('npbc-searching');
        grid.innerHTML = '';
        if (!hits.length) {
          var none = document.createElement('p');
          none.className = 'npbc-result__empty';
          none.textContent = 'No blanks match "' + q + '".';
          grid.appendChild(none);
        } else {
          /* C384f: every hit is shown ("hats" finds 273; the old 120 cap hid the rest with no pager) */
          hits.forEach(function (p) { grid.appendChild(card(p)); });
        }
        count.textContent = hits.length + (hits.length === 1 ? ' result' : ' results');
        try { decorateCards(grid); } catch (e) {}
      });
    }
    /* C384: keep the query in the address bar, so a refresh, a shared link or Back returns to the same results */
    function keepQuery(q) {
      try {
        var u = new URL(location.href);
        if (q) u.searchParams.set('q', q); else u.searchParams.delete('q');
        history.replaceState(history.state, '', u.pathname + u.search + u.hash);
      } catch (e) {}
    }

    /* 763 products is four sequential pages of 250; starting that on the first keystroke made the
       first search look broken for several seconds. Focus is the earliest honest signal. */
    input.addEventListener('focus', load, { once: true });

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim().toLowerCase();
      if (q.length >= 2 && !catalogue) count.textContent = 'Searching...';
      timer = setTimeout(function () { keepQuery(input.value.trim()); q.length < 2 ? restore() : render(q); }, 200);
    });

    /* C384: arriving from the site search (/search forwards blank searches here as ?q=), run that search straight away */
    var arrive = '';
    try { arrive = (new URL(location.href).searchParams.get('q') || '').trim(); } catch (e) {}
    if (arrive.length >= 2) {
      input.value = arrive;
      count.textContent = 'Searching...';
      render(arrive.toLowerCase());
    }
  }

  /* ── C263: collection cards get swatches, brand and an "AS LOW AS" price ────────────────────
     The theme card prints image, title, price. Brand and swatches are not available to it:
     facet_brand is a metafield the card snippet never outputs, and the swatch hex is not in
     Shopify at all (Collective drops Ninja's per-variant specs.shirt_prim_hex). Both come from
     window.NP_CARD, generated by build-card-data.py. */
  function decorateCards(root) {
    var data = window.NP_CARD;
    if (!data) return;
    var cards = (root || document).querySelectorAll('#main-collection-product-grid .product-item');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.getAttribute('data-npbc-card') === '1') continue;
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) continue;
      var handle = (link.getAttribute('href') || '').split('/products/').pop().split('?')[0].split('#')[0];
      var d = data[handle];
      var text = card.querySelector('.card__text, .product-item__text');
      if (!text) continue;
      card.setAttribute('data-npbc-card', '1');

      /* C333 (Justin 2026-09-23): swatches are the colours that can be bought. NP_CARD is a build-time
         list with no stock in it, so it showed colours sold out in every size; product-item.liquid now
         carries the in-stock names (data-np-instock), and the dots and "+N" come from those. With no
         attribute, or nothing in stock, the card falls back to NP_CARD exactly as before. */
      var dotHex = d && d.c ? d.c.slice() : [], dotName = d && d.k ? d.k.slice() : [], dotTotal = d ? (d.n || dotHex.length) : 0;
      var stockNames = (card.getAttribute('data-np-instock') || '').split('|').filter(Boolean);
      /* C402: a blank imported after np-blanks-card-data.js was built has no entry there; its swatches then come from the
         in-stock names on the card + the shared colour table, and its brand from data-np-brand. Nothing to regenerate. */
      if (!d && (stockNames.length || card.getAttribute('data-np-brand'))) d = { b: card.getAttribute('data-np-brand') || '' };
      if (d && !d.b && card.getAttribute('data-np-brand')) d.b = card.getAttribute('data-np-brand');
      if (d && stockNames.length) {
        var table = window.NP_BLANK_COLORS || {};
        dotHex = []; dotName = [];
        for (var si = 0; si < stockNames.length && dotHex.length < 5; si++) {
          var stockNm = stockNames[si];
          var at = d.k ? d.k.indexOf(stockNm) : -1;
          var hx = table[stockNm.trim().toUpperCase().replace(/\s+/g, ' ')] || (at > -1 && d.c ? d.c[at] : null);
          if (hx) { dotHex.push(hx); dotName.push(stockNm); }
        }
        dotTotal = stockNames.length;
      }
      if (dotHex.length) {
        var row = document.createElement('div');
        row.className = 'npbc-card__swatches';
        for (var j = 0; j < dotHex.length; j++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'npbc-card__dot';
          dot.style.backgroundColor = dotHex[j];
          if (dotName[j]) {
            dot.setAttribute('data-colour', dotName[j]);
            dot.setAttribute('aria-label', dotName[j]);
            dot.title = dotName[j];
          }
          row.appendChild(dot);
        }
        var extra = dotTotal - dotHex.length;
        if (extra > 0) {
          var more = document.createElement('span');
          more.className = 'npbc-card__more';
          more.textContent = '+' + extra;
          row.appendChild(more);
        }
        text.insertBefore(row, text.firstChild);
      }

      /* C274: order is swatches, then a row of [AS LOW AS / price] beside the brand, then the
         title. The price element is the theme's own, so it is MOVED into the row rather than
         duplicated — a copy would drift the moment the theme re-rendered the card. */
      var meta = document.createElement('div');
      meta.className = 'npbc-card__meta';
      var priceEl = card.querySelector('.product-item__price');
      if (priceEl) meta.appendChild(priceEl);
      if (d && d.b) {
        var brand = document.createElement('div');
        brand.className = 'npbc-card__brand';
        brand.textContent = d.b;
        meta.appendChild(brand);
      }
      var titleEl = card.querySelector('.product-item__title');
      if (titleEl) text.insertBefore(meta, titleEl);
      else text.appendChild(meta);

      /* price: "From $5.54" or "$9.32" -> stacked "AS LOW AS" label over a big green figure */
      var price = card.querySelector('.product-item__price');
      if (price) {
        var m = (price.textContent || '').match(/\$[\d,]+(?:\.\d{2})?/);
        if (m) {
          price.innerHTML = '';
          var lab = document.createElement('span');
          lab.className = 'npbc-card__aslow';
          lab.textContent = 'AS LOW AS';
          var fig = document.createElement('span');
          fig.className = 'npbc-card__price';
          fig.textContent = m[0];
          price.appendChild(lab);
          price.appendChild(fig);
          price.classList.add('npbc-card__pricewrap');
        }
      }
    }
  }

  /* ── C264: facet rows read [box] [swatch] Name .......... 854 ───────────────────────────────
     The theme's .facet-checkbox is display:grid with grid-template-columns:auto 1fr, sized for
     exactly two children: the checkbox and one text node. Injecting a swatch made a third item,
     so the name wrapped onto its own row under the swatch. Splitting "Black (622)" into a name
     and a count adds a fourth. Both need the column list widened, which is done in CSS keyed on
     the markup this function creates. */
  function splitFacetCounts(root) {
    var labels = (root || document).querySelectorAll('label.facet-checkbox');
    for (var i = 0; i < labels.length; i++) {
      var lab = labels[i];
      if (lab.getAttribute('data-npbc-row') === '1') continue;
      /* the count lives in a bare text node at the end: "Black (622)" */
      var node = null;
      for (var n = lab.childNodes.length - 1; n >= 0; n--) {
        var c = lab.childNodes[n];
        if (c.nodeType === 3 && (c.nodeValue || '').trim()) { node = c; break; }
      }
      if (!node) continue;
      var m = (node.nodeValue || '').trim().match(/^(.*?)\s*\((\d[\d,]*)\)$/);
      lab.setAttribute('data-npbc-row', '1');
      if (!m) continue;
      var name = document.createElement('span');
      name.className = 'npbc-facet__name';
      name.textContent = m[1];
      var count = document.createElement('span');
      count.className = 'npbc-facet__count';
      count.textContent = m[2];
      lab.replaceChild(count, node);
      lab.insertBefore(name, count);
    }
  }

  /* ── C266: with a Colors filter on, each card shows that colour ──────────────────────────────
     Filtering to Blue and showing the default (usually black) product photo makes the filter look
     broken. The facet value is a FAMILY ("Blue"), not a catalogue colour name, so a variant is
     chosen by nearest hex: every variant colour name resolves through the shared per-name table,
     and the closest to the family's reference colour wins. Fetched lazily per card as it scrolls
     into view and cached per handle, so an unfiltered grid costs nothing. */
  var prodCache = Object.create(null);

  function activeColourFamilies() {
    var out = [];
    try {
      new URL(window.location.href).searchParams.forEach(function (v, k) {
        if (k === 'filter.p.m.custom.facet_colors') out.push(String(v).toLowerCase());
      });
    } catch (e) {}
    return out;
  }

  function rgb(hex) {
    var h = String(hex || '').replace('#', '');
    if (h.length === 3) h = h[0]+h[0]+h[1]+h[1]+h[2]+h[2];
    if (h.length !== 6) return null;
    var n = parseInt(h, 16);
    return isNaN(n) ? null : [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  }
  function dist(a, b) {
    if (!a || !b) return Infinity;
    var dr = a[0]-b[0], dg = a[1]-b[1], db = a[2]-b[2];
    return dr*dr + dg*dg + db*db;
  }

  function loadProduct(handle) {
    if (prodCache[handle]) return prodCache[handle];
    prodCache[handle] = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return prodCache[handle];
  }

  function colourMatchCard(card, families) {
    if (card.getAttribute('data-npbc-colour') === '1') return;
    card.setAttribute('data-npbc-colour', '1');
    var link = card.querySelector('a[href*="/products/"]');
    var img = card.querySelector('img');
    if (!link || !img) return;
    var handle = (link.getAttribute('href') || '').split('/products/').pop().split('?')[0].split('#')[0];
    var target = rgb(FAMILY[families[0]] || hexFor(families[0]));
    if (!target) return;
    loadProduct(handle).then(function (p) {
      if (!p || !p.variants) return;
      var idx = -1;
      for (var i = 0; i < (p.options || []).length; i++) {
        var nm = (p.options[i].name || p.options[i] || '').toString().toLowerCase();
        if (nm === 'color' || nm === 'colour') { idx = i; break; }
      }
      if (idx < 0) return;
      var best = null, bestD = Infinity;
      for (var v = 0; v < p.variants.length; v++) {
        var variant = p.variants[v];
        var name = variant.options ? variant.options[idx] : null;
        if (!name || !variant.featured_image || !variant.featured_image.src) continue;
        var d = dist(rgb(hexFor(name)), target);
        if (d < bestD) { bestD = d; best = variant; }
      }
      /* only swap on a confident match; a far-off nearest is worse than leaving the hero photo */
      if (!best || bestD > 12000) return;
      var src = best.featured_image.src;
      img.removeAttribute('srcset');
      img.src = src.indexOf('?') > -1 ? src + '&width=480' : src + '?width=480';
    });
  }

  /* C267: clicking a swatch shows that colour on the card. One delegated listener on the grid,
     not one per dot — the grid re-renders on every filter change and per-dot listeners would be
     rebound each time. The variant is found by exact colour NAME (carried on the dot), not by
     hex, so two colours that share a hex cannot pick each other. */
  function wireDotClicks() {
    var grid = document.getElementById('main-collection-product-grid');
    if (!grid || grid.__npbcDots) return;
    grid.__npbcDots = true;
    grid.addEventListener('click', function (e) {
      var dot = e.target.closest ? e.target.closest('.npbc-card__dot') : null;
      if (!dot) return;
      e.preventDefault();
      var name = dot.getAttribute('data-colour');
      var card = dot.closest('.product-item');
      if (!name || !card) return;
      var link = card.querySelector('a[href*="/products/"]');
      var img = card.querySelector('img');
      if (!link || !img) return;
      var handle = (link.getAttribute('href') || '').split('/products/').pop().split('?')[0].split('#')[0];
      Array.prototype.forEach.call(card.querySelectorAll('.npbc-card__dot'), function (d) {
        d.classList.toggle('is-active', d === dot);
      });
      card.setAttribute('data-npbc-colour-name', name);
      loadProduct(handle).then(function (p) {
        if (!p || !p.variants) return;
        var idx = -1;
        for (var i = 0; i < (p.options || []).length; i++) {
          var nm = (p.options[i].name || p.options[i] || '').toString().toLowerCase();
          if (nm === 'color' || nm === 'colour') { idx = i; break; }
        }
        if (idx < 0) return;
        for (var v = 0; v < p.variants.length; v++) {
          var variant = p.variants[v];
          var vn = variant.options ? variant.options[idx] : null;
          if (!vn || vn.toLowerCase() !== name.toLowerCase()) continue;
          if (!variant.featured_image || !variant.featured_image.src) continue;
          var src = variant.featured_image.src;
          img.removeAttribute('srcset');
          img.src = src.indexOf('?') > -1 ? src + '&width=480' : src + '?width=480';
          return;
        }
      });
    });
  }

  function colourMatchCards() {
    var families = activeColourFamilies();
    if (!families.length) return;
    var cards = document.querySelectorAll('#main-collection-product-grid .product-item');
    if (!window.IntersectionObserver) {
      Array.prototype.forEach.call(cards, function (c) { colourMatchCard(c, families); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        colourMatchCard(e.target, families);
      });
    }, { rootMargin: '300px' });
    Array.prototype.forEach.call(cards, function (c) { io.observe(c); });
  }

  /* ── C275: the default view leads with a mix, not 250 hats ───────────────────────────────────
     The collection sorts by best selling and hats outsell everything, so the first four screens
     of /collections/blank-apparel were caps. Round-robin the rendered page across product types
     so the first screen shows what the catalogue actually holds. Only ever runs on the DEFAULT
     view: pick any sort or any filter and the order the shopper asked for is left alone. The
     sort control reads Featured in that state, because a curated mix is not "best selling" and
     labelling it so would be a lie.

     REVERTED 2026-09-22, twice wrong:
     1. appendChild moved each card to the END of the grid, past the pagination element, which
        is also a child of it. The grid rendered two cards marooned on the right and the pager
        stranded mid-page.
     2. Even fixed, it could only reorder the 32 products ALREADY on page one, and page one is
        nearly all hats because the collection sorts by best selling and hats outsell the rest.
        Shuffling a hat-only page still shows hats. Leading with a real mix needs the ORDER to
        change server side, not the rendered page. */
  function interleaveByType() {
    return;   /* C275 REVERTED — kept for the record, see the comment above */
    /* eslint-disable no-unreachable */
    var grid = document.getElementById('main-collection-product-grid');
    var data = window.NP_CARD;
    if (!grid || !data || grid.getAttribute('data-npbc-mixed') === '1') return;
    var q = window.location.search;
    if (/[?&]sort_by=/.test(q) || /[?&]filter\./.test(q) || /[?&]page=/.test(q)) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.product-item'));
    if (cards.length < 6) return;
    grid.setAttribute('data-npbc-mixed', '1');

    var buckets = [], byType = Object.create(null);
    cards.forEach(function (c) {
      var a = c.querySelector('a[href*="/products/"]');
      var h = a ? (a.getAttribute('href') || '').split('/products/').pop().split('?')[0].split('#')[0] : '';
      var t = (data[h] && data[h].t) || 'other';
      if (!byType[t]) { byType[t] = []; buckets.push(byType[t]); }
      byType[t].push(c);
    });
    if (buckets.length < 2) return;
    var out = [], i = 0;
    while (out.length < cards.length) {
      var moved = false;
      for (var b = 0; b < buckets.length; b++) {
        if (buckets[b][i]) { out.push(buckets[b][i]); moved = true; }
      }
      if (!moved) break;
      i++;
    }
    out.forEach(function (c) { grid.appendChild(c); });

    var proxy = document.querySelector('.npbc-toolbar__sort select');
    if (proxy) {
      for (var o = 0; o < proxy.options.length; o++) {
        if (proxy.options[o].value === 'manual') { proxy.selectedIndex = o; break; }
      }
    }
  }

  /* ── C398 (Justin 2026-09-23, "on mobile the blanks filter drawer should have an Apply Filters button ... closing the
     drawer does not show any loading indicator"): filters still apply the moment they are ticked (the theme's own AJAX),
     but the drawer now ends in an Apply filters button that closes it and brings the results into view, and while the
     theme is fetching (it marks the grid .loading) the page shows an "Updating results" pill and the button reads
     Applying… ─────────────────────────────────────────────────────────────────────────────────────────────────── */
  function drawerApply() {
    var sb = document.getElementById('site-filters-sidebar');
    if (!sb || sb.querySelector('.npbc-drawer-foot')) return;
    var foot = document.createElement('div');
    foot.className = 'npbc-drawer-foot';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'npbc-drawer-apply';
    btn.innerHTML = '<span class="npbc-drawer-apply__spin" aria-hidden="true"></span><span class="npbc-drawer-apply__label">Apply filters</span>';
    btn.addEventListener('click', function () {
      if (typeof sb.hide === 'function') sb.hide();
      var target = document.getElementById('CollectionProductGrid');
      if (target) {
        var y = target.getBoundingClientRect().top + window.pageYOffset - 90;
        window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
      }
    });
    foot.appendChild(btn);
    sb.appendChild(foot);
  }
  function loadingPill() {
    if (document.querySelector('.npbc-loading-pill')) return;
    var pill = document.createElement('div');
    pill.className = 'npbc-loading-pill';
    pill.setAttribute('role', 'status');
    pill.setAttribute('aria-live', 'polite');
    pill.innerHTML = '<span class="npbc-loading-pill__spin" aria-hidden="true"></span><span>Updating results…</span>';
    document.body.appendChild(pill);
  }
  function syncLoading() {
    var on = !!document.querySelector('#main-collection-product-grid.loading');
    document.body.classList.toggle('npbc-loading', on);
    var label = document.querySelector('.npbc-drawer-apply__label');
    if (label) label.textContent = on ? 'Applying…' : 'Apply filters';
  }
  (function watchLoading() {
    var box = document.getElementById('CollectionProductGrid');
    if (!box || !window.MutationObserver) return;
    new MutationObserver(syncLoading).observe(box, { attributes: true, attributeFilter: ['class'], subtree: true, childList: true });
  })();

  function run() {
    drawerApply();
    loadingPill();
    wireGroups(document);
    paintSwatches(document);
    splitFacetCounts(document);
    buildToolbar();
    decorateCards(document);
    colourMatchCards();
    wireDotClicks();
    /* C275 REVERTED: see the note on interleaveByType. */
  }

  run();
  /* The theme re-renders the facets form AND the product grid on every filter change, so every
     decoration has to be reapplied. All four are idempotent (each marks what it has touched).
     Observers stay scoped to the two containers that actually change and are rAF-debounced: a
     document-wide subtree observer here fired hundreds of times during a scroll once already. */
  if (window.MutationObserver) {
    var watch = function (target, fns) {
      if (!target) return;
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        /* C397: a timer, not requestAnimationFrame — rAF never fires in a background tab, so a filter applied while the
           shopper looked away left the re-rendered grid undecorated until they came back */
        setTimeout(function () {
          pending = false;
          for (var i = 0; i < fns.length; i++) fns[i](document);
        }, 30);
      }).observe(target, { childList: true, subtree: true });
    };
    watch(document.querySelector('.facets-sidebar'), [wireGroups, paintSwatches, splitFacetCounts]);
    /* C397 (Justin 2026-09-23, "when a filter is applied quick buy goes away it shouldn't"): a filter change makes the
       theme replace #CollectionProductGrid's contents, which throws away #main-collection-product-grid itself, so an
       observer on it went deaf after the first filter — the toolbar, card styling and quick buy never came back. Watch
       the container that survives the swap. */
    watch(document.getElementById('CollectionProductGrid') || document.getElementById('main-collection-product-grid'),
      [buildToolbar, decorateCards, colourMatchCards]);
  }
  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
})();

/* rev 1790088236 */
